<template>
  <div>
    <div class="alarm-table  personality-form">
      <el-table :data="server_data" height='330px' size="mini"
        :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #343434' }"
        class="personality-form" style="width: 100%">
        <el-table-column prop="serverId" align="center" label="服务器ID" width="170">
        </el-table-column>
        <el-table-column prop="alarmType" align="center" width="200" label="报警类型">
        </el-table-column>
        <el-table-column prop="alarmContent" align="center" label="报警描述">
        </el-table-column>
        <el-table-column prop="alarmTime" align="center" width="180" :formatter="timestampToTime" label="报警时间">
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-box">
      <el-pagination :page-size="params.pageSize" :current-page="params.pageNum" :pager-count="count"
        @current-change="pageChange" layout="prev, pager, next" :page-count="pages">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import service from '../../service/alarmService.js'
import timeExchange from '../../utils/timestampToFormat.js'
import leftService from '../../service/leftService'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      params: {
        pageSize: 1000,
        pageNum: 1,
        lastId: ''
      },
      total: 0,
      pages: 0,
      count: 11,
      server_data: [],
      loading: false,
      timestamp: 0,
      timeExchange: timeExchange,
      timer: null,
      bottom_height: `${(document.documentElement.clientHeight - 100) * 0.5 - 110}`
    }
  },
  computed: {

  },
  watch: {

  },
  mounted() {
    this.loading = true
    service.getServerAllList(this.params).then(res => {
      /* this.pages = res.pages
      this.total = res.total */
      this.server_data = res
      /* this.$store.state.alarmNum = res.total */
      this.loading = false
    }).catch(err => {
      this.$Message.error(err.message)
    })
  },
  destroyed() {
  },
  methods: {
    timestampToTime(row, column) {
      var date = new Date(row.alarmTime) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = date.getDate() + ' '
      var h = date.getHours() + ':'
      var m = date.getMinutes() + ':'
      var s = date.getSeconds()
      return Y + M + D + h + m + s
    },
    pageChange(pageNum) {
      /*  this.params.pageNum = pageNum
       this.seachAlarmList.pageNum = pageNum
       this.loading = true
       leftService.searchAlarm(this.seachAlarmList).then(res => {
         this.total = res.total
         this.alarm_data = res.data
         this.loading = false
       }) */
    },
  }
}
</script>
<style lang='scss'>
.el-tabs--border-card>.el-tabs__content {
  padding: 0px;
}

.datagrid-sort-desc .datagrid-sort-icon {
  display: none;
}

.icon-confirmi {
  width: 17px;
  height: 17px;
  background: url("/static/img/new-icno/确认.png") no-repeat center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.icon-start {
  cursor: pointer;
  width: 17px;
  height: 17px;
  background-image: url("/static/img/new-icno/清除.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 2%;
  margin-left: 10px;
}

.icon-show {
  width: 17px;
  height: 17px;
  background-image: url("/static/img/new-icno/显示报警.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 2%;
  margin-left: 10px;
}

.icon-flash {
  width: 17px;
  height: 17px;
  background-image: url("/static/img/new-icno/刷新.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 2%;
  margin-left: 10px;
}

.icon-properties {
  width: 17px;
  height: 17px;
  background-image: url("/static/img/new-icno/报警属性.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-left: 10px;
}

.icon-clears {
  width: 17px;
  height: 17px;
  background-image: url("/static/img/new-icno/清除.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-left: 10px;
}

.pagination-box {
  min-width: 620px;
  float: right;
}

//  #rMenu {
//   position:absolute;
//   visibility:hidden;
//   top:0;
//   background-color: #fff;
//   text-align: left;
//   padding: 2px;
//   border: 1px solid #DFDFDF;
//   font-size: 14px;
// }
// .right-menu-li{

// 	margin: 1px 0;
// 	padding: 5px 15px 5px 10px;
// 	cursor: pointer;
// 	list-style: none outside none;
// 	background-color: #fff;
//   border-bottom: 1px solid #DFDFDF;
// }</style>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/alarm/serverList.vue